import React from 'react';
import { XIcon } from 'lucide-react';
import { problems } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
export function Problems() {
  return <section aria-labelledby="problemas-title" className="w-full bg-ink-800" data-id="element-152" data-mp="1czwpwhwsciqm">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-20" data-id="element-153" data-mp="1cxtpr51x5986">
        <div className="mx-auto max-w-3xl text-center" data-id="element-154" data-mp="1hxy6mw6qo5yx">
          <SectionLabel data-id="element-155" data-mp="kb932hwe1lay">La realidad de las divisiones menores en Colombia</SectionLabel>
          <h2 id="problemas-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-156" data-mp="k9efevtqff36">
            Si su hijo o hija juega fútbol, estas situaciones le van a sonar conocidas
          </h2>
        </div>
        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-157" data-mp="z1opu14gd1b8">
          {problems.map(problem => <li key={problem} className="flex items-start gap-4 rounded-xl border border-ink-border bg-ink-card p-5 shadow-panel transition-colors duration-150 ease-out hover:border-red-500/40" data-id="element-158" data-mp="1k81dm3vvbnp">
              <span aria-hidden="true" className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-500/15 text-red-400" data-id="element-159" data-mp="185r72boje1f">
                <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-160" data-mp="3nnqht6teplr7" />
              </span>
              <p className="text-[15px] leading-relaxed text-body" data-id="element-161" data-mp="3nlnuwvnjw8qp">{problem}</p>
            </li>)}
        </ul>
        <div className="mt-10 rounded-2xl border border-ink-border bg-ink-950 p-8 text-center shadow-panel" data-id="element-162" data-mp="3en27am3823j2">
          <p className="font-display text-2xl font-bold leading-snug text-white md:text-3xl" data-id="element-163" data-mp="39npm05s014il">
            Ninguna familia debería tomar decisiones así de importantes a ciegas
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-base text-subtle" data-id="element-164" data-mp="17wm9fayjtfve">
            El fútbol base en Colombia no se detiene a explicarle sus reglas.{' '}
            <span className="font-semibold text-brand-greenSoft" data-id="element-165" data-mp="12y144x4fw603">Este método sí.</span>
          </p>
        </div>
      </div>
    </section>;
}